import React, {useState} from "react";
import {observer} from "mobx-react";
import styled, {css} from "styled-components";
import {ITravelTaxViewModel} from "../../services/booking/models/passenger-segment/travel-tax.view-model.interface";
import {Price} from "../../services/currency/price";
import {useServices} from "../../hooks/use-services.hook";
import {ChevronDownIcon} from "../../assets/svg/chevron-down.icon";
import {ChevronUpIcon} from "../../assets/svg/chevron-up.icon";

const CommonBox = styled.div`
    color: ${props => props.theme.colors.notesTint};
    font-size: ${props => props.theme.fontSize.caption};
`

const HeaderBox = styled(CommonBox)`
    font-weight: ${props => props.theme.fontWeight.medium};
`

const TaxesTotalLabelBox = styled(HeaderBox)`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    gap: ${props => props.theme.spacing.flexGap8};
    width: 100%;
    grid-column: 1/3;
    cursor: pointer;
    color: ${props => props.theme.colors.notesTint};
`

const TaxesTotalAmountBox = styled(HeaderBox)`
    grid-column: 3;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    cursor: pointer;
`


const TaxCellBox = styled(CommonBox)<{$isLastRow: boolean}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    ${props => !props.$isLastRow && css`
        border-bottom: 1px dotted ${props => props.theme.border.mainColor};
        padding-bottom: 4px;
    `}
    
`

const TaxDescriptionBox = styled(TaxCellBox)`
    justify-content: flex-start;
`



interface ShoppingCartTaxesComponentProps {
    taxes: ITravelTaxViewModel[];
    taxesTotal: Price;
}

export const ShoppingCartTaxesComponent: React.FC<ShoppingCartTaxesComponentProps> = observer((props) => {
    const services = useServices();
    const [isExpanded, setIsExpanded] = useState(false);
    if(props.taxes.length === 0) {
        return null;
    }

    const renderChevron = () => {
        if(isExpanded) {
            return (
                <ChevronUpIcon size={0.8}/>
            );
        } else {
            return (
                <ChevronDownIcon size={0.8}/>
            );
        }
    }

    const renderOneTax = (tax: ITravelTaxViewModel, index: number) => {
        const isLastOne = index === props.taxes.length - 1;
        return (
            <React.Fragment key={tax.code + tax.price.toString()}>
                <TaxDescriptionBox $isLastRow={isLastOne}>{tax.description}</TaxDescriptionBox>
                <TaxCellBox $isLastRow={isLastOne}>{`${tax.quantity} x ${tax.price.toString()}`}</TaxCellBox>
                <TaxCellBox $isLastRow={isLastOne}>{tax.total.toString()}</TaxCellBox>
            </React.Fragment>
        )
    }

    const renderContent = () => {
        if(!isExpanded) {
            return null;
        }

        return (
            <>
                {props.taxes.map(renderOneTax)}
            </>
        )
    }

    const onHeaderClick = () => {
        setIsExpanded(!isExpanded);
    }

    return (
        <>
            <TaxesTotalLabelBox onClick={onHeaderClick}>
                    <span>
                        {services.language.translate('Taxes, fees and charges (included)')}
                    </span>
                {renderChevron()}
            </TaxesTotalLabelBox>

            <TaxesTotalAmountBox onClick={onHeaderClick}>
                {props.taxesTotal.toString()}
            </TaxesTotalAmountBox>
            {renderContent()}
        </>
    )
})